'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var common = {
  black: '#000',
  white: '#fff'
};

exports.default = common;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-beta/colors/common.js
// module id = 1080
// module chunks = 0